import { useState } from "react"

import { AppSidebar } from "@/components/layouts/app-layout/app-sidebar"
import { SidebarSearchButton } from "@/components/sidebar/sidebar-search-button"
import { SidebarGroup, SidebarMenu, SidebarMenuItem } from "@/components/ui/sidebar"
import { useSidebar } from "@/components/ui/use-sidebar"
import { useRoutes } from "@/contexts/use-routes"
import { ChatHistory } from "@/features/chat/components/chat-history"
import { StartNewChatButton } from "@/features/chat/components/start-new-chat-button"
import { useStartNewChat } from "@/features/chat/hooks/use-start-new-chat"
import { useCurrentSessionType } from "@/hooks/use-current-session-type"
import { cn } from "@/lib/utils"
import { useAIParserStore } from "@/stores/ai-parser-store"
import { useParserJobsStore } from "@/stores/parser-jobs-store"

import { useActiveParserJobs } from "../hooks/use-active-parser-jobs"

export function AIParserSidebar() {
  const { state, isMobile } = useSidebar()
  const { routes } = useRoutes()

  const sessionType = useCurrentSessionType()

  const parserStore = useAIParserStore(sessionType)
  const { handleStartNewChat } = useStartNewChat({
    useChatStore: () => parserStore,
    sessionType,
  })

  const [globalSearch, setGlobalSearch] = useState("")

  const moduleRoute = routes.find((r) => r.id === sessionType)

  useActiveParserJobs()
  const activeSessionIds = useParserJobsStore((state) => state.activeSessionIds)

  if (!moduleRoute) {
    return null
  }

  const isCollapsed = state === "collapsed" && !isMobile

  return (
    <AppSidebar onLogoClick={handleStartNewChat}>
      <SidebarGroup className="bg-sidebar sticky top-0 z-40 gap-2 p-2 pb-0">
        <SidebarMenu>
          <SidebarMenuItem className={cn("flex", isCollapsed ? "justify-center" : "")}>
            <StartNewChatButton iconOnly={isCollapsed} onStartNewChatClick={handleStartNewChat} />
          </SidebarMenuItem>
        </SidebarMenu>
        {!isCollapsed && (
          <SidebarSearchButton searchValue={globalSearch} onSearchChange={setGlobalSearch} />
        )}
      </SidebarGroup>

      <SidebarGroup
        className={cn("flex flex-col gap-2 p-2", isCollapsed ? "items-center pt-1" : "")}
      >
        <ChatHistory
          globalSearchTerm={globalSearch}
          hideSharing={true}
          processingSessionIds={activeSessionIds}
          sessionType={sessionType}
          useChatStore={() => parserStore}
        />
      </SidebarGroup>
    </AppSidebar>
  )
}
